import { a as e, n as t, r as n, t as r } from "./eventBus-BwFpUh5d.js";
import { n as i, r as a, t as o } from "./editor-image-state-overlay-BPFTeb65.js";
import { a as ee, c as s, d as c, f as l, i as u, l as d, m as f, n as p, o as m, p as h, r as g, s as _, t as v, u as y } from "./image.service-BZ-WQOP-.js";
import { Fragment as te, computed as b, createBlock as x, createCommentVNode as S, createElementBlock as C, createElementVNode as w, createTextVNode as T, createVNode as E, defineAsyncComponent as D, defineComponent as O, mergeModels as k, mergeProps as ne, normalizeClass as A, onBeforeMount as re, openBlock as j, ref as M, toDisplayString as N, unref as P, useModel as ie, vShow as ae, watch as oe, withCtx as F, withDirectives as se } from "vue";
import { QBadge as ce, QBtn as le, QCard as ue, QCardSection as I, QDialog as de, QIcon as L, QImg as R, QInput as z, QTooltip as B, useFormChild as fe } from "quasar";
import { BCheckbox as V, PLACEHOLDER_UUID as H, quasarValidateRules as pe, vGermanQuotes as me } from "@editor/ui-utils";
import { useI18n as he } from "vue-i18n";
//#region src/selectors/image-list.selector.vue?vue&type=script&setup=true&lang.ts
var ge = { class: "row justify-center items-center align-center text-center" }, _e = { class: "col" }, ve = {
	key: 0,
	class: "required"
}, ye = { class: "col q-pa-md" }, be = { class: /* @__PURE__ */ A(["container-wrapper"]) }, xe = {
	key: 0,
	class: "row"
}, Se = { class: "col" }, Ce = { class: "image-description" }, we = { class: "text-wrap image-list-content" }, Te = { class: "text-wrap image-list-content q-ml-sm q-mr-sm q-mt-sm" }, Ee = { class: "text-wrap image-list-licence text-muted q-ml-sm q-mr-sm q-mb-xs" }, De = { class: "q-field__messages text-negative col" }, Oe = ["textContent"], U = /* @__PURE__ */ f(/* @__PURE__ */ O({
	__name: "image-list.selector",
	props: /* @__PURE__ */ k({
		label: { default: void 0 },
		imgData: { default: void 0 },
		modelValue: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		},
		isSquare: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		},
		state: { default: void 0 },
		license: { default: void 0 },
		rules: { default: void 0 },
		horizontal: {
			type: Boolean,
			default: !0
		},
		type: { default: void 0 },
		selectedBrand: { default: void 0 },
		disableBrand: {
			type: Boolean,
			default: !1
		},
		selectedImageList: { default: void 0 },
		multi: {
			type: Boolean,
			default: !1
		},
		showPartnerImages: {
			type: Boolean,
			default: !1
		}
	}, {
		additionalArticleCaption: {},
		additionalArticleCaptionModifiers: {}
	}),
	emits: /* @__PURE__ */ k([
		"update:image",
		"update:imageMulti",
		"update:modelValue"
	], ["update:additionalArticleCaption"]),
	setup(n, { expose: i, emit: ee }) {
		let c = D(() => import("./image-edit-Wuoz2bfo.js")), l = D(() => import("./image-list-tkwuzvnJ.js")), u = n, d = ee, f = ie(n, "additionalArticleCaption"), p = r(), m = () => ({
			_id: "",
			title: "",
			source: "",
			state: "draft",
			caption: "",
			credits: "",
			changeDate: /* @__PURE__ */ new Date(),
			createDate: /* @__PURE__ */ new Date(),
			height: 0,
			width: 0,
			isDeleted: !1,
			license: [],
			legacy: {
				source: "vibe",
				isEditableInCTF: !0,
				isRenderedByCTF: !0,
				hasBeenModifiedInCTF: !0
			}
		}), h = t(), g = M(m()), _ = M(""), v = M(""), y = M(""), O = M(!1), k = M(!1), V = M(!0), U = M(""), W = M(), G = e().apiUploads.multipartFormFile / (1024 * 1024);
		i({ ImageData: g });
		let K = () => {
			let e = pe(g.value, u.rules);
			V.value = !e, U.value = e;
		};
		fe({
			validate() {
				return K(), V.value || W.value?.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center"
				}), V.value;
			},
			resetValidation() {
				V.value = !0, U.value = "";
			}
		});
		let q = b(() => u.isSquare ? y.value : _.value), J = () => {
			u.modelValue || (h.clearAll(), g.value = m()), u.disable || (O.value = !0);
		}, Y = (e) => {
			g.value = e, k.value = !0, d("update:image", e), d("update:modelValue", g.value._id), O.value = !1;
		}, ke = (e) => {
			d("update:imageMulti", e), O.value = !1;
		}, { t: X } = he(), Ae = b(() => u.label ? u.label : X("components.imageUploadLabel", { maxFileSize: G })), Z = () => {
			O.value = !1, k.value = !1;
		}, Q = b(() => {
			let e = g.value?.license || [], t = u.selectedBrand, n, r;
			t && e.includes(t) ? (n = t, r = e.filter((e) => e !== t)) : [n, ...r] = e.sort();
			let i = r.sort().join(", ");
			return {
				mainBrand: n,
				tooltipText: i
			};
		}), $ = () => {
			g.value = m(), U.value = "", d("update:image", void 0), d("update:modelValue"), k.value = !1, Z();
		}, je = async (e) => {
			let t = e[0];
			if (!t) return;
			let n = g.value?.state !== "publish" && t.state === "publish";
			g.value = t, d("update:modelValue", t._id), k.value = !1;
			let r = await s(t._id, !0);
			g.value = r.image, y.value = r.squarePreview || r.image.source, _.value = r.widePreview || r.image.source, v.value = r.ultraWidePreview || r.image.source, d("update:image", r.image), n && (O.value = !1);
		};
		return p.on("updateImage", async (e) => {
			if (e._id === u.imgData?._id) {
				g.value = e, K(), y.value = e.source, _.value = e.source, v.value = e.source;
				return;
			}
			if (u.modelValue === e._id) {
				let e = await s(u.modelValue, !0);
				g.value = e.image, K(), y.value = e.squarePreview || e.image.source, _.value = e.widePreview || e.image.source, v.value = e.ultraWidePreview || e.image.source;
			}
		}), re(async () => {
			if (u.imgData) {
				g.value = u.imgData, y.value = u.imgData.source, _.value = u.imgData.source, v.value = u.imgData.source;
				return;
			}
			if (u.modelValue) {
				let e = await s(u.modelValue, !0);
				g.value = e.image, y.value = e.squarePreview || e.image.source, _.value = e.widePreview || e.image.source, v.value = e.ultraWidePreview || e.image.source;
			}
		}), oe(() => u.modelValue, async () => {
			if (u.modelValue) {
				let e = await s(u.modelValue, !0);
				g.value = e.image, y.value = e.squarePreview || e.image.source, _.value = e.widePreview || e.image.source, v.value = e.ultraWidePreview || e.image.source;
			} else g.value = m();
			U.value = "";
		}, {
			deep: !0,
			immediate: !0
		}), (e, t) => (j(), C("div", {
			ref_key: "wrapper",
			ref: W,
			class: "q-pa-none"
		}, [E(P(ue), { class: A(["q-pa-none no-shadow", { invalid: !V.value }]) }, {
			default: F(() => [n.modelValue ? (j(), x(P(I), {
				key: 1,
				style: { height: "100%" },
				class: A(["q-pa-none q-mt-md border-item", { invalid: !V.value }])
			}, {
				default: F(() => [w("div", { class: A(["image-picker-content", ["row", { column: !n.horizontal }]]) }, [w("div", ye, [w("div", be, [n.type === "image" || u.type === "video" || n.type === "gallery" || n.type === "download" ? (j(), C("div", xe, [w("div", { class: A(["col-4", { square: n.isSquare }]) }, [g.value._id && g.value._id !== P(H) ? (j(), x(P(R), {
					key: 0,
					"data-qa-preview": "",
					class: "custom-image",
					src: q.value,
					onClick: J
				}, {
					default: F(() => [g.value ? (j(), x(o, {
						key: 0,
						image: g.value
					}, null, 8, ["image"])) : S("", !0)]),
					_: 1
				}, 8, ["src"])) : (j(), x(a, {
					key: 1,
					class: "custom-image"
				}))], 2), w("div", Se, [w("div", Ce, [w("div", we, N(g.value.title), 1), f.value === void 0 ? S("", !0) : se((j(), x(P(z), {
					key: 0,
					modelValue: f.value,
					"onUpdate:modelValue": t[1] ||= (e) => f.value = e,
					label: P(X)("articleBlocks.captionForArticle"),
					disable: n.disable,
					type: "textarea",
					outlined: "",
					dense: "",
					rows: "2",
					class: "q-mt-sm",
					"data-qa-image-additional-caption-field": ""
				}, null, 8, [
					"modelValue",
					"label",
					"disable"
				])), [[P(me)]])])])])) : n.type === "image" ? S("", !0) : (j(), C(te, { key: 1 }, [
					g.value._id && g.value._id !== P(H) ? (j(), x(P(R), {
						key: 0,
						"data-qa-preview": "",
						class: "custom-image",
						src: q.value,
						onClick: J
					}, {
						default: F(() => [g.value ? (j(), x(o, {
							key: 0,
							image: g.value
						}, null, 8, ["image"])) : S("", !0)]),
						_: 1
					}, 8, ["src"])) : (j(), x(a, {
						key: 1,
						class: "custom-image"
					})),
					w("div", Te, N(g.value.title), 1),
					w("div", Ee, [w("span", null, N(P(X)("videos.license")) + ": " + N(Q.value.mainBrand), 1), se(E(P(ce), {
						color: "grey-9 image-badge",
						"text-color": "white",
						class: "q-mx-sm"
					}, {
						default: F(() => [T(" +" + N(g.value.license.length - 1) + " ", 1), E(P(B), {
							anchor: "top middle",
							self: "top middle",
							offset: [10, 30],
							class: "bg-grey-10 text-white shadow-4"
						}, {
							default: F(() => [T(N(Q.value.tooltipText), 1)]),
							_: 1
						})]),
						_: 1
					}, 512), [[ae, Q.value.tooltipText]])])
				], 64))])]), w("div", { class: A(["image-picker-actions", [{ "q-my-sm text-center c-btn": !n.horizontal }]]) }, [E(P(le), {
					class: "image-picker-remove-button",
					"data-qa-image-picker-remove-button": "",
					flat: "",
					round: "",
					icon: "close",
					color: "grey-7",
					size: "sm",
					disable: n.disable,
					onClick: $
				}, {
					default: F(() => [E(P(B), null, {
						default: F(() => [T(N(P(X)("common.remove")), 1)]),
						_: 1
					})]),
					_: 1
				}, 8, ["disable"])], 2)], 2)]),
				_: 1
			}, 8, ["class"])) : (j(), x(P(I), {
				key: 0,
				"data-qa-image-picker": "",
				class: A(["custom-image-wrapper q-mt-md border-item border-item--dashed custom-add-image", { invalid: !V.value }]),
				onClick: J
			}, {
				default: F(() => [w("div", ge, [w("div", _e, [
					g.value.title ? S("", !0) : (j(), x(P(L), {
						key: 0,
						size: "36px",
						name: "image",
						color: "grey-5"
					})),
					E(P(z), ne({
						modelValue: g.value.title,
						"onUpdate:modelValue": t[0] ||= (e) => g.value.title = e,
						class: "hidden",
						"append-icon": "external-link",
						clearable: "",
						readonly: "",
						borderless: ""
					}, e.$attrs, {
						"onClick:clear": Y,
						"onClick:append": J
					}), null, 16, ["modelValue"]),
					g.value.title ? S("", !0) : (j(), x(P(I), {
						key: 1,
						"data-qa-image-title": "",
						flat: "",
						class: "q-pa-sm",
						color: "white"
					}, {
						default: F(() => [T(N(Ae.value) + " ", 1), n.required ? (j(), C("span", ve)) : S("", !0)]),
						_: 1
					}))
				])])]),
				_: 1
			}, 8, ["class"])), U.value ? (j(), x(P(I), {
				key: 2,
				class: "q-field__bottom row items-start q-field__bottom--animated"
			}, {
				default: F(() => [w("div", De, [w("div", {
					role: "alert",
					textContent: N(U.value)
				}, null, 8, Oe)])]),
				_: 1
			})) : S("", !0)]),
			_: 1
		}, 8, ["class"]), E(P(de), {
			modelValue: O.value,
			"onUpdate:modelValue": t[3] ||= (e) => O.value = e,
			"data-qa-image-modal": "",
			"allow-focus-outside": "",
			"full-width": "",
			"full-height": "",
			onHide: Z
		}, {
			default: F(() => [!n.modelValue && !k.value ? (j(), x(P(l), {
				key: 0,
				dialog: !0,
				state: n.state,
				license: n.license,
				"disable-brand": n.disableBrand,
				"selected-image-list": n.selectedImageList,
				multi: n.multi,
				"show-partner-images": n.showPartnerImages,
				"onNew:clicked": t[2] ||= (e) => k.value = !0,
				"onBack:modal": Z,
				onClose: $,
				"onClick:image": Y,
				"onClick:imageMulti": ke
			}, null, 8, [
				"state",
				"license",
				"disable-brand",
				"selected-image-list",
				"multi",
				"show-partner-images"
			])) : n.modelValue ? (j(), x(P(c), {
				key: 2,
				id: n.modelValue,
				dialog: !0,
				title: P(X)("router.editImage"),
				"back-route": void 0,
				"onBack:modal": Z,
				onClose: $,
				onSaveImages: je
			}, null, 8, ["id", "title"])) : (j(), x(P(c), {
				key: 1,
				dialog: !0,
				title: P(X)("router.createImage"),
				"back-route": void 0,
				"onBack:modal": Z,
				onClose: $,
				onSaveImages: je
			}, null, 8, ["title"]))]),
			_: 1
		}, 8, ["modelValue"])], 512));
	}
}), [["__scopeId", "data-v-ca873423"]]), W = { class: "q-mt-md" }, G = { class: "row justify-content-center align-items-center q-mt-md" }, K = { class: "q-mr-md" }, q = { class: "q-mr-md" }, J = /* @__PURE__ */ O({
	__name: "image-channel-content-block",
	props: /* @__PURE__ */ k({
		license: {},
		locked: { type: Boolean },
		rules: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = ie(e, "modelValue"), { t: n } = he();
		return (r, i) => (j(), C("div", W, [
			E(U, {
				modelValue: t.value.imageUuid,
				"onUpdate:modelValue": i[0] ||= (e) => t.value.imageUuid = e,
				"data-qa": "channel-image-stage-image-picker",
				state: "publish",
				disable: e.locked,
				license: e.license,
				rules: e.rules,
				type: "image"
			}, null, 8, [
				"modelValue",
				"disable",
				"license",
				"rules"
			]),
			E(P(z), {
				modelValue: t.value.imageLinkOutUrl,
				"onUpdate:modelValue": i[1] ||= (e) => t.value.imageLinkOutUrl = e,
				"data-qa": "channel-image-url-field",
				label: P(n)("articleBlocks.imageUrl"),
				class: "q-mt-lg",
				placeholder: P(n)("articleBlocks.imagePlaceholder"),
				disable: e.locked,
				dense: "",
				outlined: ""
			}, null, 8, [
				"modelValue",
				"label",
				"placeholder",
				"disable"
			]),
			w("div", G, [
				w("div", K, [E(P(V), {
					modelValue: t.value.hasNoFollow,
					"onUpdate:modelValue": i[2] ||= (e) => t.value.hasNoFollow = e,
					"data-qa": "channel-image-hasnofollow",
					class: "col-3",
					label: P(n)("articleBlocks.noFollow"),
					dense: "",
					disable: e.locked
				}, null, 8, [
					"modelValue",
					"label",
					"disable"
				]), E(P(L), {
					name: "info",
					class: "q-ml-sm"
				}, {
					default: F(() => [E(P(B), {
						class: "bg-grey-10 text-white shadow-4",
						"max-width": "400px",
						anchor: "top middle",
						self: "bottom middle",
						offset: [10, 10]
					}, {
						default: F(() => [T(N(P(n)("articleBlocks.noFollowTooltip")), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				E(P(V), {
					modelValue: t.value.hasNewTab,
					"onUpdate:modelValue": i[3] ||= (e) => t.value.hasNewTab = e,
					"data-qa": "channel-image-hasnewtab",
					class: "col-3",
					label: P(n)("articleBlocks.newTab"),
					dense: "",
					disable: e.locked
				}, null, 8, [
					"modelValue",
					"label",
					"disable"
				]),
				w("div", q, [E(P(V), {
					modelValue: t.value.isBound,
					"onUpdate:modelValue": i[4] ||= (e) => t.value.isBound = e,
					"data-qa": "channel-image-isbound",
					class: "col-3",
					label: P(n)("articleBlocks.bound"),
					dense: "",
					disable: e.locked
				}, null, 8, [
					"modelValue",
					"label",
					"disable"
				]), E(P(L), {
					name: "info",
					class: "q-ml-sm"
				}, {
					default: F(() => [E(P(B), {
						class: "bg-grey-10 text-white shadow-4",
						"max-width": "400px",
						anchor: "top middle",
						self: "bottom middle",
						offset: [10, 10]
					}, {
						default: F(() => [T(N(P(n)("articleBlocks.boundTooltip")), 1)]),
						_: 1
					})]),
					_: 1
				})])
			])
		]));
	}
});
//#endregion
//#region src/composits/useAdditionalCaption.ts
function Y({ getTarget: e, originalImage: t }) {
	let n = M(!1), r = null;
	return oe([() => t.value?.caption || t.value?.title, () => e()?.additionalCaption], ([, e]) => {
		e !== r && (n.value = !1, r = null);
	}), b({
		get: () => {
			let r = e();
			if (!r) return "";
			let i = t.value?.caption || t.value?.title || "";
			return r.additionalCaption === void 0 || r.additionalCaption.trim() === "" && !n.value ? i : r.additionalCaption;
		},
		set: (i) => {
			let a = e();
			if (!a) return;
			let o = t.value?.caption || t.value?.title || "";
			n.value = !0, r = i, i.trim() === o.trim() ? (delete a.additionalCaption, r = null) : i.trim() === "" ? a.additionalCaption = "" : a.additionalCaption = i.trim();
		}
	});
}
//#endregion
//#region src/lang/index.ts
var ke = {
	en: {
		images: {
			contentBlockLabel: "Image",
			twoImagesContentBlockLabel: "Two images",
			twoImagesLayout: "Image layout",
			twoImagesDoublePicture: "Double picture",
			twoImagesDragSlider: "Comparison drag slider",
			leftImage: "Select or upload image",
			rightImage: "Select or upload image",
			leftLabel: "Label",
			rightLabel: "Label",
			components: {
				imagesOversizeOne: "The image is too large. The maximum upload size is {maxFileSize} MB.",
				imagesOversizeMulti: "The images are too large. The maximum upload size is {maxFileSize} MB.",
				imageSelectorHintInvalid: "Invalid image",
				imageSelectorHintUnknown: "Unknown error",
				uploadImage: "Upload image",
				editImage: "Edit image",
				imageSelect: "Select",
				imageSelected: "Selected",
				imageExpiresIn: "Expires in {n} days",
				imageExpired: "Unpublished",
				imageExpires: "Expires",
				imagePublish: "Online in {n} days",
				imageCreated: "Creation date",
				imageTitle: "Title",
				imageCredits: "Credit",
				imageStatus: "Status",
				aspectText: "Preview for different image sizes based on the focal point",
				aspectTeaser: "Teaser image on mobile",
				aspectTitle: "Teaser image article/home/channel on mobile, desktop, tablet",
				aspectDesktop: "Teaser image home/channel on desktop",
				aspectDesc: "After setting the focal point, the preview is visible here after saving.",
				aspectClick: "Please focus on the square image",
				imageDeleted: "Deleted",
				imageDraft: "Draft",
				selectorNotPublishedWarning: "Warning: This image will not be visible in the published article."
			},
			title: "Title",
			altText: "Alt text",
			altTextHint: "If not filled, the title is used",
			captionTextHint: "If not filled, the title is used",
			captionOriginalHint: "Caption of the original image. Any changes will affect all articles in which the original caption is used.",
			caption: "Caption",
			selectImage: "Select or upload image. Maximum file size: {maxFileSize} MB or 30 million pixels (height x width)",
			addImage: "Add image",
			removeImage: "Remove image",
			source: "Credit",
			aiGenerated: "AI generated",
			license: "License",
			publishedAt: "Publish date",
			expiredAt: "Unpublish date",
			msn: "MSN Service",
			deleteImage: "Delete image",
			messageConfirmDelete: "Are you sure you want to delete the image?",
			messageMaxFileSize: "The maximum file size is {maxFileSize} MB.",
			messageMandatoryInformation: "The image cannot be saved because mandatory information is missing.",
			messageUpload: "Image uploaded",
			messageSaved: "Image saved",
			messageTooBig: "The image is too large. The maximum file size is {maxFileSize} MB.",
			messageDeleted: "Image deleted",
			messagePublishTitle: "Publish image",
			messagePublish: "Are you sure you want to publish this image?",
			messageDeleteImageTitle: "Delete image",
			messageDeleteImage: "Are you sure you want to delete this image?",
			messageConfirmUnpublishImage: "Are you sure you want to unpublish the image?",
			messageUnpublishTitle: "Unpublish image",
			messageConfirmDraftImage: "Are you sure you want to unpublish this image?",
			messageRepublishInFuture: "Are you sure you want to unpublish the image and schedule it to be published in the future?",
			messageRepublishInFutureTitle: "Reschedule publishing",
			messageTooSmall: "The image resolution is below the minimal requirement of 1200 x 675 pixels. Please upload a larger one.",
			messageTooHighResolution: "Images larger than 30 million pixels are not selectable for image upload.",
			saveDraft: "Save draft",
			saveOffline: "Unpublish",
			savePublish: "Publish",
			saveScheduled: "Schedule publication",
			invalid: "Invalid",
			setFocalPoint: "Set the focal point by clicking on the image.",
			articleLabel: "Article",
			invalidVideoCover: "Unpublished",
			invalidVideoCoverTooltip: "This video has an expired image preview.",
			deletedVideoCover: "Deleted",
			deletedVideoCoverTooltip: "The image preview for this video has been deleted.",
			notAnImageFile: "The selected file is not an image.",
			modeUnpublished: "Image unpublished",
			modeScheduled: "Publish date scheduled",
			modePublished: "Published",
			modeDraft: "Draft",
			noEditTooltip: "This image is originally from {source} editor.",
			handledInLegacySystem: "This image is being handled in {source} and cannot be edited in Vibe.",
			failedToLoadImage: "Error loading image"
		},
		imagesList: {
			addSelected: "Add selected images",
			title: "Image",
			newButton: "New image",
			multi: "Add selected images",
			search: "Search for title, caption or alt text",
			status: "Status",
			dpAll: "All",
			dpSchedule: "Scheduled",
			dpPublished: "Published",
			dpExpired: "Unpublished",
			date: "Creation date",
			credits: "Credit",
			uuid: "Image UUID",
			noImages: "There are no images matching the search criteria.",
			xymatic: "Show video images",
			showPartnerImages: "Show partner images",
			partnerImageBadge: "Partner image"
		}
	},
	de: {
		images: {
			contentBlockLabel: "Bild",
			twoImagesContentBlockLabel: "Bildvergleich",
			twoImagesLayout: "Layout",
			twoImagesDoublePicture: "Zwei Bilder",
			twoImagesDragSlider: "Vergleichs-Slider",
			leftImage: "Bild hochladen",
			rightImage: "Bild hochladen",
			leftLabel: "Beschriftung",
			rightLabel: "Beschriftung",
			components: {
				imagesOversizeOne: "Das Bild ist zu groß. Die maximale Uploadgröße ist {maxFileSize} MB.",
				imagesOversizeMulti: "Die Bilder sind zu groß. Die maximale Uploadgröße ist {maxFileSize} MB.",
				imageSelectorHintInvalid: "Ungültiges Bild",
				imageSelectorHintUnknown: "Unbekannter Fehler",
				uploadImage: "Bild hochladen",
				editImage: "Bild bearbeiten",
				imageSelect: "Auswählen",
				imageSelected: "Ausgewählt",
				imageExpiresIn: "Läuft in {n} Tagen ab",
				imagePublish: "Online in {n} Tagen",
				imageExpired: "Depubliziert",
				imageExpires: "Läuft ab",
				imageCreated: "Erstellungsdatum",
				imageTitle: "Titel",
				imageCredits: "Credit",
				imageStatus: "Status",
				aspectText: "Vorschau für verschiedene Bildgrößen basierend auf dem Fokuspunkt",
				aspectTeaser: "Teaserbild auf Mobile",
				aspectTitle: "Teaserbild Artikel/Home/Channel auf Mobile, Desktop, Tablet",
				aspectDesktop: "Teaserbild Home/Channel auf Desktop",
				aspectDesc: "Ist der Fokuspunkt gesetzt, ist die Vorschau nach dem Speichern hier sichtbar.",
				aspectClick: "Bitte auf das quadratische Bild fokussieren",
				imageDeleted: "Gelöscht",
				imageDraft: "Entwurf",
				selectorNotPublishedWarning: "Achtung: Dieses Bild wird im veröffentlichten Artikel nicht sichtbar sein."
			},
			title: "Titel",
			altText: "Alt-Text",
			altTextHint: "Wenn nicht befüllt, wird der Bild-Titel genutzt",
			captionTextHint: "Wenn nicht befüllt, wird der Bild-Titel genutzt",
			captionOriginalHint: "Bildunterschrift des Originalbildes. Eine Änderung wirkt sich auf alle Artikel aus, in denen die ursprüngliche Bildunterschrift verwendet wird.",
			caption: "Bildunterschrift",
			selectImage: "Bild hochladen. Maximale Dateigröße: {maxFileSize}MB oder 30 Mio. Pixel (Breite x Höhe)",
			addImage: "Bild hinzufügen",
			removeImage: "Bild entfernen",
			source: "Credit",
			aiGenerated: "KI-generiert",
			license: "Lizenz",
			publishedAt: "Veröffentlichungsdatum (publish date)",
			expiredAt: "Ablaufdatum",
			msn: "MSN-Service",
			deleteImage: "Bild löschen",
			messageConfirmDelete: "Willst du das Bild wirklich löschen?",
			messageMaxFileSize: "Die maximale Dateigröße ist {maxFileSize} MB.",
			messageMandatoryInformation: "Das Bild kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			messageUpload: "Bild hochgeladen",
			messageSaved: "Bild gespeichert",
			messageTooBig: "Das Bild ist zu groß. Die maximale Dateigröße ist {maxFileSize} MB.",
			messageDeleted: "Bild gelöscht",
			messagePublishTitle: "Bild veröffentlichen",
			messagePublish: "Willst du das Bild wirklich veröffentlichen?",
			messageDeleteImageTitle: "Bild löschen",
			messageDeleteImage: "Willst du das Bild wirklich löschen?",
			messageConfirmUnpublishImage: "Willst du das Bild wirklich depublizieren?",
			messageUnpublishTitle: "Bild depublizieren",
			messageConfirmDraftImage: "Willst du das Bild wirklich depublizieren?",
			messageRepublishInFuture: "Willst du das Bild wirklich depublizieren und eine spätere Wiederveröffentlichung planen?",
			messageRepublishInFutureTitle: "Veröffentlichung verschieben",
			messageTooSmall: "Die Bildauflösung liegt unter der Mindestanforderung von 1200 x 675 Pixeln. Bitte ein größeres hochladen.",
			messageTooHighResolution: "Bilder über 30 Millionen Pixel können nicht für den Bild-Upload ausgewählt werden.",
			saveDraft: "Entwurf speichern",
			saveOffline: "Depublizieren",
			savePublish: "Veröffentlichen",
			saveScheduled: "Veröffentlichung planen",
			invalid: "Ungültig",
			setFocalPoint: "Zum Setzen des Fokuspunkts auf das Bild klicken.",
			articleLabel: "Artikel",
			invalidVideoCover: "Depubliziert",
			invalidVideoCoverTooltip: "Die Bildvorschau für dieses Video ist abgelaufen.",
			deletedVideoCover: "Gelöscht",
			deletedVideoCoverTooltip: "Die Bildvorschau für dieses Video ist gelöscht.",
			notAnImageFile: "Die ausgewählte Datei ist kein Bild.",
			modeUnpublished: "Bild depubliziert",
			modeScheduled: "Veröffentlichung geplant",
			modePublished: "Veröffentlicht",
			modeDraft: "Entwurf",
			noEditTooltip: "Dieses Bild stammt ursprünglich aus dem {source}-Editor.",
			handledInLegacySystem: "Dieses Bild wird in {source} bearbeitet, Sie können es nicht auf Vibe bearbeiten",
			failedToLoadImage: "Fehler beim Laden des Bildes"
		},
		imagesList: {
			addSelected: "Ausgewählte Bilder hinzufügen",
			title: "Bild",
			newButton: "Neues Bild",
			multi: "Ausgewählte Bilder hinzufügen",
			search: "Suchen nach Titel, Bildunterschrift oder Alt-Text",
			status: "Status",
			dpAll: "Alle",
			dpSchedule: "Geplant",
			dpPublished: "Veröffentlicht",
			dpExpired: "Depubliziert",
			date: "Erstellungsdatum",
			credits: "Credit",
			uuid: "Bild-UUID",
			noImages: "Es gibt keine Bilder, die die Suchkriterien erfüllen.",
			xymatic: "Videobilder anzeigen",
			showPartnerImages: "Partnerbilder anzeigen",
			partnerImageBadge: "Partner-Bild"
		}
	}
}, X = D(() => import("./editor-image-Csjp6b4A.js").then((e) => e.n)), Ae = D(() => import("./image-edit-Wuoz2bfo.js")), Z = D(() => import("./image-list-tkwuzvnJ.js")), Q = {
	routes: [],
	messages: {
		en: {},
		de: {}
	}
};
//#endregion
export { J as ChannelImageBlock, X as EditorImage, a as EditorImagePlaceholder, Ae as ImageEdit, Z as ImageList, U as ImageListSelector, v as ImageModelName, p as ImageService, g as createImage, u as deleteImage, ee as editImage, m as getDefaultImageBlock, _ as getDefaultTwoImagesBlock, s as getImage, d as getImageUrl, y as getImages, Q as imageComponentsModule, ke as messages, n as prefillEditorImage, c as replaceImage, i as stateChangeIn, l as updateImage, h as uploadImage, Y as useAdditionalCaption };

//# sourceMappingURL=index.es.js.map